module.exports = __webpack_public_path__ + "assets/img/Nexon-2-Landing-Page-w960.efa2419f.jpg";